import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import PlotTooltip from 'PhenotypeView/views/plr/components/PlotTooltip/PlotTooltip';
export const usePlotTooltip = () => (useCallback((association) => (_jsx(PlotTooltip, { phenotypeAssociation: association }, void 0)), []));
